import { render, staticRenderFns } from "./acceptTerms.vue?vue&type=template&id=6c68a4c7&"
import script from "./acceptTerms.vue?vue&type=script&lang=js&"
export * from "./acceptTerms.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports